import React, { useState } from "react";

export interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabProps {
  tabs: Tab[];
}

const TabComponent: React.FC<TabProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className="flex w-full flex-col">  
        <div className="flex overflow-x-scroll no-scrollbar">
        <ul className="flex border-b border-neutral cursor-pointer">
            {tabs.map((tab, index) => (
            <li
                key={index}
                onClick={() => handleClick(index)}
                className={`-mb-px w-max py-2 rounded-t-md transition-all duration-500 ease-in-out ${activeTab === index ? " bg-neutral  border-indigo-500" : "border-transparent"}`}
            >
                <a
                className={`${
                    activeTab === index ? "text-white font-quicksand-semibold" : "text-gray-500 hover:text-gray-700"
                } px-4`}
                href="#"
                onClick={() => handleClick(index)}
                >
                {tab.label}
                </a>
            </li>
            ))}
        </ul>

        </div>
        <div className="flex w-full">
            {tabs.map((tab, index) => (
            <div key={index} className={activeTab === index ? "flex w-full block" : "hidden"}>
                {tab.content}
            </div>
            ))}
        </div>
    </div>
  );
};

export default TabComponent;
